// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: -  Object Definition
export class RichTextSpanAttribute {
    // --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
    // MARK: - Constructor
    constructor(model) {
        var _a, _b;
        this.type = model.type;
        this.link = (_a = model.link) !== null && _a !== void 0 ? _a : null;
        // TODO:fix-sdk-eslint
        // eslint-disable-next-line no-prototype-builtins
        if (model.hasOwnProperty("openInNewWindow")) {
            this.openInNewWindow = model.openInNewWindow;
        }
        else {
            this.openInNewWindow = false;
        }
        this.documentationItemId = (_b = model.documentationItemId) !== null && _b !== void 0 ? _b : null;
    }
}
